import React, { useEffect, useState } from "react";
import { faThumbsUp as ThumbsUpO } from "@fortawesome/free-regular-svg-icons";
import { faDownload, faThumbsUp as ThumbsUpS } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "../../styles/view-doc.css";
import "../../styles/notes.css";
import "../../styles/search.css";
import "../../styles/main.css";

import { RightNav } from "../../components/main-components/right-nav";
import { formatUrl } from "../../helpers/parse-url";
import { BmsHeader } from "../../components/main-components/app.header";
import { commentPublication, getCommentsByPostId, loadById } from "../../services/documents/documents.context";
import { useAuth } from "../../services/authentication/authentication.context";
import { AppAlert } from "../../components/utilities/alert";
import { Loader } from "../../components/utilities/loader";
import { likeDocument } from "../../services/documents/documents.context";




export const ViewDocument = () => {

    const { token, userData } = useAuth();

    const document = useLocation().state?.notes;

    const [doc, setDoc] = useState(document);

    const likedArray = doc?.likes;

    const _id = userData?._id;
    const docLiked = likedArray?.includes(_id);



    const [liked, setLiked] = useState(docLiked);
    const [comment, setComment] = useState('');
    const [response, setResponse] = useState();
    const [loading, setLoading] = useState(false);
    const [postComments, setPostComments] = useState([]);

    const id = document._id;

    const postComment = async () => {
        setLoading(true);
        const resp = await commentPublication(id, token, comment);
        console.log(resp);
        setResponse(resp);
        setLoading(false);
    }

    useEffect(() => {
        (async () => {
            const comments = await getCommentsByPostId(id);
            setPostComments(comments);
            const thisDoc = await loadById(id);
            setDoc(thisDoc);
        })();
        console.log(likedArray);
    }, [id, likedArray]);


    return (
        <div className="page-body">
            <BmsHeader />
            {response &&
                <AppAlert
                    caption={response?.error ? "Error" : "Success"}
                    accept={"Ok"}
                    acceptAction={() => setResponse()}
                />}
            {loading && <Loader />}
            <div className='straight-box'>
                helo
            </div>
            <div className='straight-box'>
                helo
            </div>
            <div className="notes-page">
                <div className="main-page">
                    <div className="notes_view_box">
                        <object
                            className="pdf-view"
                            type="application/pdf"
                            data={formatUrl(document?.document)}
                            width="100%"
                            height="100%"
                            onLoadedData={() => alert("completed")}
                        >
                            <div className="loading -text">Pdf loading...</div>
                            <a href={formatUrl(document?.document)} >
                                {document?.title}
                                <button className="download-pdf">
                                    <FontAwesomeIcon icon={faDownload} />
                                </button>
                            </a>

                        </object>

                        <span className="mob-load" >
                            <span className="descr">No preview available for mobile</span>
                            <a className="down-link" href={formatUrl(document?.document)} >
                                Click here to download
                                <FontAwesomeIcon icon={faDownload} />
                            </a>
                        </span>
                    </div>
                    <div className="left-center">
                        <div className="like-status">Like&nbsp;&nbsp;</div>
                        <button
                            className="like-btn"
                            onClick={() => {
                                setLiked((v) => (!v));
                                likeDocument(id, token);
                            }
                            }
                        >
                            {!liked ?
                                <FontAwesomeIcon icon={ThumbsUpO} className="unlike" /> :
                                <FontAwesomeIcon icon={ThumbsUpS} className="unlike" />
                            }
                            <i className="fa-regular fa-thumbs-up like"></i>
                        </button>
                    </div>
                    <div className="like-err"></div>
                    <div className="comments">
                        <div className="comment-caption">Add a comment</div>
                        <form className="add-comment">
                            <div className="comment-box">
                                <textarea
                                    placeholder="Type your comments here"
                                    className="comment-area"
                                    name="foot_notes"
                                    id="footnote" cols="30" rows="7" required
                                    onChange={(e) => setComment(e.target.value)}
                                ></textarea>
                            </div>
                            <div className="button_box">
                                <button
                                    className="submit_doc"
                                    id="add-comment"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        postComment();
                                    }}
                                >
                                    <span className="upload_icon"><i className="fa fa-commenting-o"></i></span>
                                    Post comment
                                </button>
                            </div>
                        </form>
                    </div>
                    <div className="see-comments">
                        <div className="comment-caption">Comments</div>
                        {postComments.map((comment, k) => {
                            return (
                                <div className="comment-unit" key={k}>
                                    <div className="comment-details">
                                        <img className="user-avatar" src={formatUrl(comment?.commenter.avatar)} alt="" />
                                        <span className="commenter">{comment?.commenter.names}</span>
                                    </div>
                                    <div className="unit-bottom">
                                        <span className="comment-text">{comment.comment}</span>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <RightNav />
            </div>
        </div>
    );
}